
import { useCallback } from 'react';
import { useResearchNavigation } from './use-research-navigation';

interface UseResearchCardActionsProps {
  onResearchClick: (researchId: string) => void;
  onToggleFavorite: (researchId: string) => Promise<void>;
}

export const useResearchCardActions = ({ onResearchClick, onToggleFavorite }: UseResearchCardActionsProps) => {
  const { navigateToGenerateResearch } = useResearchNavigation();

  const handleGenerateResearch = useCallback(() => {
    console.log('Research generation triggered');
  }, []);

  const handleResearchGenerated = useCallback((research: any) => {
    console.log('Research generated successfully:', research);
    
    // The research parameter is the raw database record from generation
    // We need to auto-open the lightbox with the new research
    if (research && research.id) {
      console.log('Auto-opening lightbox for generated research:', research.id);
      
      // Immediate auto-open - don't wait for cache to update
      // The research data is fresh from the generation response
      onResearchClick(research.id);
    }
  }, [onResearchClick]);

  return {
    navigateToGenerateResearch,
    handleGenerateResearch,
    handleResearchGenerated,
    onResearchClick,
    onToggleFavorite,
  };
};
